// extracted by mini-css-extract-plugin
module.exports = {"support":"support_support__2xRxV","show":"support_show__3MdMx","canvas":"support_canvas__3xMLQ"};